export default {
  BACK: 'back',
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  ENTER: 'enter',

  RED: 'red',
  GREEN: 'green',
  YELLOW: 'yellow',
  BLUE: 'blue',

  CH_UP: 'ch_up',
  CH_DOWN: 'ch_down',

  PLAY: 'play',
  PLAY_PAUSE: 'play_pause',
  PAUSE: 'pause',
  RW: 'rw',
  FF: 'ff',
  STOP: 'stop',
  NEXT_TRACK: 'next_track',
  PREV_TRACK: 'prev_track',

  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  ZERO: 'zero',

  VOLUP: 'volup',
  VOLDOWN: 'voldown',
  MUTE: 'mute',

  EXIT: 'exit',
  SHOW_POINTER: 'show_pointer',
  HIDE_POINTER: 'hide_pointer',
};
